import { useState } from "react";

export default function SignupModal() {
  const [info, setInfo] = useState({
    firstname: "",
    lastname: "",
    code: "",
    phone: "",
    birthdate: "",
    email: "",
  });
  return (
    <div
      className="modal fade"
      id="sign-up-user"
      tabindex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered the-modal1">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body p-5">
            <div className="row">
              <label
                for="firstname"
                className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label"
              >
                نام
              </label>
              <div className="mb-3 col-12 col-sm-6 col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  id="firstname"
                  value={info.firstname}
                  onChange={(e) =>
                    setInfo({ ...info, firstname: e.target.value })
                  }
                  required
                />
              </div>
              <label
                for="lastname"
                className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
              >
                نام خانوادگی
              </label>
              <div className="mb-3 col-12 col-sm-6 col-lg-3">
                <input
                  type="text"
                  className="form-control"
                  id="lastname"
                  value={info.lastname}
                  onChange={(e) =>
                    setInfo({ ...info, lastname: e.target.value })
                  }
                  required
                />
              </div>
              <label
                for="code"
                className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label"
              >
                کدملی
              </label>
              <div className="mb-3 col-12 col-sm-6 col-lg-3">
                <input
                  type="text"
                  className="form-control"
                  id="code"
                  value={info.code}
                  onChange={(e) => setInfo({ ...info, code: e.target.value })}
                  required
                />
              </div>
            </div>
            <div className="row">
              <label
                for="phone"
                className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
              >
                شماره تماس
              </label>
              <div className="mb-3 col-12 col-sm-6 col-lg-4">
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  value={info.phone}
                  onChange={(e) => setInfo({ ...info, phone: e.target.value })}
                  required
                />
              </div>
              <label
                for="birthdate"
                className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
              >
                تاریخ تولد
              </label>
              <div className="mb-3 col-12 col-sm-6 col-lg-4">
                <input
                  type="text"
                  className="form-control"
                  id="birthdate"
                  value={info.birthdate}
                  onChange={(e) =>
                    setInfo({ ...info, birthdate: e.target.value })
                  }
                  required
                />
              </div>
            </div>
            <div className="mb-3 row">
              <label
                for="email"
                className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
              >
                ایمیل
              </label>
              <div className="mb-3 col-12 col-sm-6 col-lg-4">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  value={info.email}
                  onChange={(e) => setInfo({ ...info, email: e.target.value })}
                  required
                />
              </div>
              <button
                type="button"
                className="col-12 col-sm-5 col-lg-3 btn btn-primary the-btn"
                data-bs-dismiss="modal"
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
